export default __webpack_public_path__ + "static/media/green4en.fc7ca57b.jpg";